import React from "react";
import styles from "src/modules/common/general/ui/Footer/Footer.module.scss";
import cl from "classnames";
import { SocialNetwork } from "src/modules/common/general/ui/SocialNetwork/SocialNetwork";
import { useIntl } from "react-intl";
import logo from "src/modules/common/general/assets/img/common/png/Logo.svg";
import { HashLink } from "react-router-hash-link";
import logoMobile from "src/modules/common/general/assets/img/common/png/LogoMobile@2x.png";

export const Footer: React.FC = () => {
	// const navigate = useNavigate();
	const intl = useIntl();
	return (
		<footer className={styles.footer}>
			<div className={cl(styles.footerContainer, styles.container)}>
				<div className={styles.footer__logo}>
					<img
						srcSet={`${logoMobile} 2x`}
						src={logo}
						alt={""}
						className={styles.logo}
						width={167}
						height={81}
					/>
				</div>
				<div className={styles.footer__content}>
					<div className={cl(styles.footer__main)}>
						<div className={cl(styles.footer__text)}>
							{intl.formatMessage({
								id: "Play-to-Collect traditional board game built on the blockchain technology",
							})}
						</div>
						<SocialNetwork />
						<div className={cl(styles.footer__text)}>
							{intl.formatMessage({ id: "Contact us" })}: welcome@pixudi.com
						</div>
						<div
							className={cl(styles.footer__madeby)}
							onClick={() => {
								window.open("https://kapcrew.com", "_blank");
							}}
						>
							{intl.formatMessage({ id: "made by" })} kapcrew
							<svg
								width="21"
								height="21"
								viewBox="0 0 21 21"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clipPath="url(#clip0_134_295)">
									<path
										d="M10.3346 11.1765L12.4117 12.9174C12.9523 13.3704 13.5951 13.6852 14.2845 13.8344C14.945 13.9774 15.63 13.9644 16.2846 13.7964L16.377 13.7727C17.8685 13.3899 19.4023 12.4265 19.953 10.9885L20.132 10.6264C20.2685 10.3503 20.3409 10.0469 20.3438 9.73888M10.3346 11.1765C7.62878 8.90866 3.64889 7.59025 0.702857 9.5359M10.3346 11.1765C11.3044 10.4189 12.3502 9.74794 13.5097 9.33581C15.8604 8.50034 17.6084 8.52889 20.3147 9.73888M20.3438 10.5C20.3438 15.9366 15.9366 20.3438 10.5 20.3438C5.06345 20.3438 0.65625 15.9366 0.65625 10.5C0.65625 5.06345 5.06345 0.65625 10.5 0.65625C15.9366 0.65625 20.3438 5.06345 20.3438 10.5Z"
										stroke="url(#paint0_linear_134_295)"
									/>
								</g>
								<defs>
									<linearGradient
										id="paint0_linear_134_295"
										x1="1.82329"
										y1="-2.03302"
										x2="23.5912"
										y2="26.6863"
										gradientUnits="userSpaceOnUse"
									>
										<stop stopColor="#00FEFE" />
										<stop offset="1" stopColor="#006BE9" />
									</linearGradient>
									<clipPath id="clip0_134_295">
										<rect width="21" height="21" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
					<div className={cl(styles.footer__subs)}>
						<div className={cl(styles.footer__sub)}>
							<div className={cl(styles.footer__btn)}>
								<div className={cl(styles.disabled)}>{intl.formatMessage({ id: "Pixudi World" })}</div>

								<svg
									width="36"
									height="19"
									viewBox="0 0 36 19"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<rect
										x="0.5"
										y="0.5"
										width="35"
										height="18"
										rx="9"
										stroke="url(#paint0_linear_696_231)"
									/>
									<path
										d="M6.80499 6.78C6.80499 6.16667 7.03833 5.69667 7.50499 5.37C7.97833 5.03667 8.56499 4.87 9.26499 4.87C10.1117 4.87 10.8417 5.04667 11.455 5.4V6.49C10.8617 6.09 10.1617 5.89667 9.35499 5.91C8.42833 5.91 7.96499 6.19333 7.96499 6.76C7.96499 7.03333 8.10166 7.26333 8.37499 7.45C8.64833 7.63 8.98166 7.78 9.37499 7.9C9.76833 8.02 10.1617 8.15667 10.555 8.31C10.9483 8.46333 11.2817 8.69667 11.555 9.01C11.8283 9.31667 11.965 9.7 11.965 10.16C11.965 10.8467 11.715 11.35 11.215 11.67C10.7217 11.9833 10.0883 12.1367 9.31499 12.13C8.38166 12.13 7.55499 11.9267 6.83499 11.52V10.4C7.54833 10.86 8.34833 11.09 9.23499 11.09C10.2817 11.09 10.805 10.8 10.805 10.22C10.805 9.96667 10.705 9.75 10.505 9.57C10.3117 9.39 10.065 9.25333 9.76499 9.16C9.47166 9.06667 9.15166 8.95667 8.80499 8.83C8.45833 8.69667 8.13499 8.56 7.83499 8.42C7.54166 8.27333 7.29499 8.06 7.09499 7.78C6.90166 7.5 6.80499 7.16667 6.80499 6.78ZM13.3925 11.46C12.8858 11.0133 12.6325 10.3933 12.6325 9.6C12.6325 8.80667 12.8858 8.18667 13.3925 7.74C13.9058 7.29333 14.5192 7.07 15.2325 7.07C15.9525 7.07 16.5658 7.29333 17.0725 7.74C17.5792 8.18667 17.8325 8.80667 17.8325 9.6C17.8325 10.3933 17.5792 11.0133 17.0725 11.46C16.5658 11.9067 15.9525 12.13 15.2325 12.13C14.5192 12.13 13.9058 11.9067 13.3925 11.46ZM16.3225 10.73C16.6025 10.4433 16.7425 10.0667 16.7425 9.6C16.7425 9.13333 16.6025 8.76 16.3225 8.48C16.0425 8.19333 15.6792 8.05 15.2325 8.05C14.7792 8.05 14.4125 8.19333 14.1325 8.48C13.8525 8.76 13.7125 9.13333 13.7125 9.6C13.7125 10.0667 13.8525 10.4433 14.1325 10.73C14.4125 11.01 14.7792 11.15 15.2325 11.15C15.6792 11.15 16.0425 11.01 16.3225 10.73ZM19.33 11.46C18.8233 11.0133 18.57 10.3933 18.57 9.6C18.57 8.80667 18.8233 8.18667 19.33 7.74C19.8433 7.29333 20.4567 7.07 21.17 7.07C21.89 7.07 22.5033 7.29333 23.01 7.74C23.5167 8.18667 23.77 8.80667 23.77 9.6C23.77 10.3933 23.5167 11.0133 23.01 11.46C22.5033 11.9067 21.89 12.13 21.17 12.13C20.4567 12.13 19.8433 11.9067 19.33 11.46ZM22.26 10.73C22.54 10.4433 22.68 10.0667 22.68 9.6C22.68 9.13333 22.54 8.76 22.26 8.48C21.98 8.19333 21.6167 8.05 21.17 8.05C20.7167 8.05 20.35 8.19333 20.07 8.48C19.79 8.76 19.65 9.13333 19.65 9.6C19.65 10.0667 19.79 10.4433 20.07 10.73C20.35 11.01 20.7167 11.15 21.17 11.15C21.6167 11.15 21.98 11.01 22.26 10.73ZM25.7575 7.86C26.1975 7.33333 26.7542 7.07 27.4275 7.07C28.0275 7.07 28.5075 7.25333 28.8675 7.62C29.2275 7.98 29.4075 8.45 29.4075 9.03V12H28.3375V9.17C28.3375 8.79667 28.2342 8.51333 28.0275 8.32C27.8208 8.12 27.5508 8.02 27.2175 8.02C26.6908 8.02 26.2442 8.28667 25.8775 8.82V12H24.8075V7.2H25.7575V7.86Z"
										fill="white"
									/>
									<defs>
										<linearGradient
											id="paint0_linear_696_231"
											x1="-9"
											y1="-4.09804"
											x2="40.2673"
											y2="-9.18154"
											gradientUnits="userSpaceOnUse"
										>
											<stop stopColor="#00A3FF" />
											<stop offset="1" stopColor="#FD38F5" />
										</linearGradient>
									</defs>
								</svg>
							</div>
							<HashLink
								to="/#Parchments"
								smooth
								className={cl(styles.footer__btn)}
							>
								{intl.formatMessage({ id: "Boards" })}
							</HashLink>
							<HashLink
								to="#Parchments"
								smooth
								className={cl(styles.footer__btn)}
							>
								{intl.formatMessage({ id: "Characters" })}
							</HashLink>
							<HashLink
								to="#Parchments"
								smooth
								className={cl(styles.footer__btn)}
							>
								{intl.formatMessage({ id: "Game Items" })}
							</HashLink>
							<HashLink
								to="#Parchments"
								smooth
								className={cl(styles.footer__btn)}
							>
								{intl.formatMessage({ id: "Pets" })}
							</HashLink>
							<div
								className={cl(styles.footer__btn, styles.footer__sub3In2Row)}
								onClick={() => {
									window.open("https://docs.pixudi.com", "_blank");
								}}
							>
								{intl.formatMessage({ id: "Litepaper" })}
							</div>
						</div>
						<div className={cl(styles.footer__sub)}>
							<HashLink
								to="#FindRandomSets"
								smooth
								className={cl(styles.footer__btn)}
							>
								{intl.formatMessage({ id: "Mystery Packs" })}
							</HashLink>
							<HashLink
								to="#PlayToCollect"
								smooth
								className={cl(styles.footer__btn)}
							>
								{intl.formatMessage({ id: "Play-to-Collect" })}
							</HashLink>
							<HashLink
								to="#TokenSystem"
								smooth
								className={cl(styles.footer__btn)}
								onClick={() => {
									// scrollToRef(RefRoadmap)
								}}
							>
								{intl.formatMessage({ id: "Tokenomics" })}
							</HashLink>
							<HashLink to="#Roadmap" smooth className={cl(styles.footer__btn)}>
								{intl.formatMessage({ id: "Roadmap" })}
							</HashLink>
							<HashLink
								to="#HaveAnyQuestions"
								smooth
								className={cl(styles.footer__btn, styles.footer__sub3In2Row)}
							>
								{intl.formatMessage({ id: "Get in Touch" })}
							</HashLink>
							{/* footer__sub3In2Row */}
						</div>
						<div className={cl(styles.footer__sub, styles.footer__sub3)}>
							<div
								className={cl(styles.footer__btn)}
								onClick={() => {
									window.open("https://docs.pixudi.com", "_blank");
								}}
							>
								{intl.formatMessage({ id: "Litepaper" })}
							</div>
							<HashLink
								to="#HaveAnyQuestions"
								smooth
								className={cl(styles.footer__btn)}
							>
								{intl.formatMessage({ id: "Get in Touch" })}
							</HashLink>
							<div className="" style={{ opacity: 0 }}>
								s
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};
